import { Lock, Mail } from "lucide-react";
import { Button } from "@/frontend/components/ui/button";
import { supportMailto } from "@/frontend/utils/support";

/** Inline banner shown above a locked settings sub-section's tiles. Points users at support instead of an in-app upgrade flow. */
export function SectionLockBanner({ label }: { label: string }) {
  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border border-dashed bg-muted/30 px-4 py-3">
      <div className="flex items-center gap-2 text-sm">
        <Lock className="size-4 text-muted-foreground shrink-0" />
        <span>
          {label} is available on the Enterprise plan. Contact support to upgrade.
        </span>
      </div>
      <Button asChild size="sm" variant="outline" className="shrink-0">
        <a href={supportMailto(`Upgrade ${label}`)}>
          <Mail className="size-4 mr-2" />
          Contact support
        </a>
      </Button>
    </div>
  );
}
